enum OnboardingGroup {
  HOMEPAGE = 'HOMEPAGE',
  SETTINGS = 'SETTINGS',
  READING_EXPERIENCE = 'READING_EXPERIENCE',
  PERSONALIZED_FEATURES = 'PERSONALIZED_FEATURES',
}

export default OnboardingGroup;
